import angular from 'angular';

class PayseraConfig {
    constructor($rootElement) {
        this.$rootElement = $rootElement;
    }

    get(value, namespace) {
        var data = angular.fromJson(this.$rootElement.attr(namespace ||'data-config'));

        return (angular.isObject(data) && (value in data)) ? data[value] : null;
    }
}

PayseraConfig.$inject = ['$rootElement'];

export default PayseraConfig;
